import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store liabilityCounters data
    endpoint: endpoints.liability_counter.endpoint, // "liability-counter",
    liabilityCounters: [],
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the liabilityCounters data
    liabilityCounters: state => state.liabilityCounters,
    liabilityCounterByID: state => id => {
      for (const liabilityCounter of state.liabilityCounters) {
        if (liabilityCounter.eid === id) return liabilityCounter;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.LIABILITY_COUNTERS_LOAD](state, liabilityCounters) {
      state.liabilityCounters = JSON.parse(JSON.stringify(liabilityCounters));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
              context.commit(types.LIABILITY_COUNTERS_LOAD, r.data.rows);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
